import { REFRESH_TOKEN_KEY, TOKEN_KEY, USER_KEY } from './config';

export function persistAuthResponse(data) {
    if (data?.token) {
        localStorage.setItem(TOKEN_KEY, data.token);
    }
    if (data?.user) {
        localStorage.setItem(USER_KEY, JSON.stringify(data.user));
    }
    if (data?.refresh_token) {
        localStorage.setItem(REFRESH_TOKEN_KEY, data.refresh_token);
    }
}

export function clearAuthStorage() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
}

export function getStoredRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function hasStoredSession() {
    return Boolean(localStorage.getItem(USER_KEY));
}

export function getStoredUser() {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
}
